import to from 'await-to-js';
import axios from 'axios';
import getCfData from 'cloudflare-user-data';
import { getIpUrl, getIpUrlBackup } from '../config/SiteConfig';
import setUserData from './setUserData';

let err, res;

export default async () => {
	if (!window.userData) {
		//? Cloudflare.
		[err, res] = await to(getCfData());
		!err && setUserData({ ip: res.ip, country: res.loc, countryName: res.loc });

		//? First IP API.
		[err, res] = await to(axios({ method: 'get', url: getIpUrl }));
		err = err || !res.data.success; // Check API limit exceeded using `res.data.success`.
		!err && setUserData({ ip: res.data.ip, country: res.data.country_code, countryName: res.data.country_name });

		//? Backup.
		if (err) {
			[err, res] = await to(axios({ method: 'get', url: getIpUrlBackup }));
			!err &&
				setUserData({ ip: res.data.ip, country: res.data.country_code, countryName: res.data.country_name });

			// Still nothing and not userData set? Save the code from getting errors then.
			err && !window.userData && setUserData({ ip: undefined, country: undefined, countryName: undefined });
		}
	}

	return window.userData;
};
